import { useEffect } from "react";
import { LOCAL_STORAGE_KEYS } from "../utils/global_variables";
import { getActiveUser, getDecryptLocalStorage, getStorageWithMultiTabCheck, setEncryptLocalStorage } from "../utils/global_functions";
import { useSelector } from "react-redux";
import { debounce } from "lodash";

const useIdleLock = ({ timeout, onLock, onUnlock }) => {//custom hook to trigger autolock
    //autoLockSessionObj is an object containing values for each user
    const modals = useSelector(state => state.modals.modals)
    const objLoginSession = useSelector(state => state?.auth?.objLoginSession);
    useEffect(() => {
        const activeUser = getActiveUser(objLoginSession)
        const autoLockSessionObj = JSON.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.AUTO_LOCK_SESSIONS));
        const isAutoLockEnabled = autoLockSessionObj?.[activeUser]?.isEnabled;
        const isModalOpen = modals['AUTO_LOCK_MODAL'];
        const path = ['/', '/onboarding', '/register', '/environmentSetting', '/forgetMpin', '/forgotPassword']
        const excludePaths = path.findIndex(value => value.toLocaleLowerCase() === window.location.pathname.toLocaleLowerCase());
        if ((excludePaths !== -1 && !getStorageWithMultiTabCheck(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION)) || !activeUser) {
            return
        }
        //this function needs to be here
        const handleStorage = (event) => {//to check in multiple tabs
            if (event.key === LOCAL_STORAGE_KEYS.AUTO_LOCK_SESSIONS) {
                //getting latest value of local storage
                const shouldLock = JSON.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.AUTO_LOCK_SESSIONS))?.[activeUser]?.isModalOpen;
                if (shouldLock) {
                    onLock(autoLockSessionObj, activeUser);
                } else {
                    onUnlock(autoLockSessionObj, activeUser);
                }
            }
        }
        const debounceStorage = debounce(handleStorage, 200)
        window.addEventListener('storage', debounceStorage);

        if (autoLockSessionObj?.[activeUser]?.isModalOpen && !isModalOpen) {// To open AutoLock modal on Refresh
            onLock(autoLockSessionObj, activeUser);
            return;
        }
        if (!isAutoLockEnabled ||
            isNaN(timeout) ||
            isModalOpen) {// check to not call modal again and again
            return;
        }
        let timer = setTimeout(onLock, timeout);

        const resetTimer = () => {//timer reset for autolock
            clearTimeout(timer);
            timer = setTimeout(onLock, timeout);
        };
        const debouncedReset = debounce(resetTimer, 100);
        const events = ['mousemove', 'keydown', 'mousedown', 'touchstart'];

        events.forEach(e => window.addEventListener(e, debouncedReset));

        return () => {
            clearTimeout(timer);
            debouncedReset.cancel();
            events.forEach(e => window.removeEventListener(e, debouncedReset));
            window.removeEventListener('storage', debounceStorage);
        };
    }, [timeout, onLock, modals, onUnlock, objLoginSession]);
}
export default useIdleLock;
